import { Loader, Switch } from 'components/Blocks';

import { actions, hasTogglePermission, ProjectTag } from 'entities';

import { useUser } from 'hooks/user';
import { useTeamProfile } from '../context';

interface ProjectTagStatusProps {
  children?: never;
  tag: ProjectTag;
}

export function ProjectTagStatus({ tag }: ProjectTagStatusProps): JSX.Element {
  const user = useUser();

  const { updateTeam } = useTeamProfile();

  const { id, disabled } = tag;

  const toggle = actions.teams.toggleTag.use({
    onSuccess: () =>
      updateTeam((old) => ({
        ...old,

        projectTags: old.projectTags.map((existingTag) =>
          existingTag.id === id ? { ...existingTag, disabled: !disabled } : existingTag,
        ),
      })),
  });

  if (toggle.loading) return <Loader type="dualRing" />;

  return (
    <Switch
      disabled={!hasTogglePermission(user, tag.team || '')}
      checked={!disabled}
      onChange={() => toggle.execute({ disabled: !disabled, id: id! })}
      size="small"
    />
  );
}
